import script from "./InventoryImport.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryImport.vue?vue&type=script&setup=true&lang=js"

import "./InventoryImport.vue?vue&type=style&index=0&id=26ec7f87&lang=less&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ec7f87"]])

export default __exports__